import { Platform } from 'react-native';
import iconFont from 'react-native-vector-icons/Fonts/FontAwesome.ttf';
import fontRubik from '../assets/fonts/Rubik-Regular.ttf';
import fontRubikBold from '../assets/fonts/Rubik-Bold.ttf';
import fontRubikSemiBold from '../assets/fonts/Rubik-SemiBold.ttf';

import nav from './Nav';
import view from './View';
import form from './Form';
import map from './Map';
import button from './Button';
import buttonfsf from './ButtonFSF';
import common, {
  primaryColor,
  primaryColorWithOpacity,
  primaryColorWeakOpacity,
  primaryColorMildOpacity,

  primaryFontRegular,
  primaryFontSemiBold,
  primaryFontBold,

  primaryFont300,
  primaryFont400,
  primaryFont500,
  primaryFont600,
  primaryFont700,
} from './Common';
import appBadge from './components/AppBadge';
import reviewBadge from './components/ReviewBadge';
import endpointBadge from './components/EndpointBadge';
import publisherBadge from './components/PublisherBadge';
import publisherIcon from './components/PublisherIcon';
import myApps from './views/MyApps';
import purchase from './views/Purchase';

import publisherApps from './views/create/PublisherApps';
import publisherAppEdit from './views/create/PublisherAppEdit';

const create = {
  publisherApps,
  publisherAppEdit,
};

const styles = {
  primaryColor, // this is not a style but used directly by many components
  primaryColorWithOpacity, // this is not a style but used directly by many components
  primaryColorWeakOpacity,
  primaryColorMildOpacity,

  primaryFontRegular,
  primaryFontSemiBold,
  primaryFontBold,

  primaryFont300,
  primaryFont400,
  primaryFont500,
  primaryFont600,
  primaryFont700,

  nav,
  view,
  form,
  map,
  button,
  buttonfsf,
  common,
  appBadge,
  reviewBadge,
  endpointBadge,
  publisherBadge,
  publisherIcon,
  myApps,
  purchase,

  create,
};

const initVectorIcons = true;
if (initVectorIcons && Platform.OS === 'web') {
  // Generate required css
  const iconFontStyles = `@font-face {
    src: url(${iconFont});
    font-family: FontAwesome;
    font-display: swap;
  }
  @font-face {
    src: url(${fontRubik});
    font-family: 'Rubik';
    font-display: swap;
  }
  @font-face {
    src: url(${fontRubik});
    font-family: 'Rubik';
    font-weight: 300;
    font-display: swap;
  }
  @font-face {
    src: url(${fontRubik});
    font-family: 'Rubik';
    font-weight: 400;
    font-display: swap;
  }
  @font-face {
    src: url(${fontRubikSemiBold});
    font-family: 'Rubik';
    font-weight: 500;
    font-display: swap;
  }
  @font-face {
    src: url(${fontRubikSemiBold});
    font-family: 'Rubik';
    font-weight: 600;
    font-display: swap;
  }
  @font-face {
    src: url(${fontRubikBold});
    font-family: 'Rubik';
    font-weight: 700;
    font-display: swap;
  }
  @font-face {
    src: url(${fontRubikBold});
    font-family: 'Rubik';
    font-weight: bold;
    font-display: swap;
  }
  `;

  // Create stylesheet
  const style = document.createElement('style');
  style.type = 'text/css';
  if (style.styleSheet) {
    style.styleSheet.cssText = iconFontStyles;
  } else {
    style.appendChild(document.createTextNode(iconFontStyles));
  }

  // Inject stylesheet
  document.head.appendChild(style);
}

export default styles;
